import { Directive, HostBinding } from '@angular/core';
import { CdkHeaderCell } from '@angular/cdk/table';

@Directive({
  selector: 'mcrai-th',
  host: {
    '[class.mcrai-th]': 'true'
  }
})
export class HeaderCellDirective extends CdkHeaderCell { }
